<template>
    <div class="container is-widescreen">
      <p
                  class="title has-text-left is-size-5 has-text-black"
                  v-t="'Project.sessions_title'"
                ></p>
      <div class="columns is-centered is-multiline">
          <div class="column is-5 session-box" v-for="session in transformedSessions"
          :key="session._id" :style="{'border-color':session.itemColor}">
            <div class="media">
              <figure class="media-left">
                <p class="image is-64x64">
                  <img :src="session.mainImage[0].fileUrl" />
                </p>
              </figure>
              <div class="media-content">
                <div class="content">
                  <h5 class="is-6" :style="{'color':session.itemColor}">{{ session.title }}</h5>
                  <p v-html="session.description"></p>
                </div>
              </div>
            </div>
          </div>
      </div>
    </div>
</template>

<script>
import { fetchItems } from '@/services/API'
import { languageManager } from '@/mixins/LanguageManager'
import { sortBy } from 'underscore'
export default {
  mixins: [languageManager],
  props: {
    projectId: {
      type: String,
      default: null
    }
  },
  mounted () {
    fetchItems('session', {
      parent: this.projectId,
      status: 'enabled'
    }).then(result => {
      this.sessions = result.data
    })
  },
  data () {
    return {
      sessions: []
    }
  },
  computed: {
    transformedSessions () {
      let _sessions = this.sessions.map(session => {
        return this.transformObject(session)
      })

      return sortBy(_sessions, item => {
        return item.order
      })
    }
  }
}
</script>

<style scoped>
.session-box {
  border-radius: 9px;
  border: solid 1px;
  padding: 1.25rem;
  margin: 1rem;
}
</style>
